import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPath: null,
  previousPath: null,
};

// Setting current and previous paths of navigation
const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    updateRoute: (state, action) => {
      if (state.currentPath != action.payload) {
        state.previousPath = state.currentPath;
        state.currentPath = action.payload;
      }
    },
  },
});

export const { updateRoute } = routeSlice.actions;

export default routeSlice.reducer;
